import styled from 'styled-components';
import { MAT_ASPECT } from '../Board/layout';

/**
 * A desktop-sized screen, turned: the board takes the full height and the panel the rest of the width, with room for
 * the game's log under your hand. Used by the styles here and by the screen (useWideScreen), so they agree.
 */
export const WIDE_SCREEN = '(orientation: landscape) and (min-width: 1000px)';

/** The whole screen, inside the phone's safe area. Its size is what the board and panel divide between them. */
export const Viewport = styled.div`
  height: 100dvh;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  overflow: hidden;
`;

/**
 * Upright: the opponent across the top, the board in the middle taking whatever is left, your turn and hand below.
 * Turned: the board on the left, everything else down the right side.
 *
 * Every track is minmax(0, …) so a long hand scrolls inside its tray instead of widening the screen.
 */
export const Screen = styled.div`
  height: 100%;
  display: grid;

  @media (orientation: portrait) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr) auto;
    grid-template-areas: "top" "board" "panel";
  }

  @media (orientation: landscape) {
    grid-template-columns: minmax(0, 1fr) min(340px, 46vw);
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas: "board top" "board panel";
  }

  /* The mat at full height needs its own width and no more; the panel gets what's left, within reason. */
  @media ${WIDE_SCREEN} {
    grid-template-columns: minmax(0, 1fr) clamp(340px, calc(100vw - 100dvh * ${MAT_ASPECT}), 640px);
  }
`;

export const BoardArea = styled.div`
  grid-area: board;
  container-type: size;
  min-height: 0;
  display: flex;
`;

export const Top = styled.div`
  grid-area: top;
  min-width: 0;

  @media (orientation: landscape) {
    background: rgba(0, 0, 0, .3);
  }
`;

export const Panel = styled.div`
  grid-area: panel;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: rgba(0, 0, 0, .3);

  @media (orientation: landscape) {
    overflow-y: auto;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 0;
  font-size: 14px;

  & a {
    text-decoration: none;
    font-weight: 600;
  }
`;
